// use for ie11 compatibility. GetBoundingClientRect get width witout margin in IE11
export const outerWidth = (el: HTMLElement): number => {
  let width = el.offsetWidth;
  const style = window.getComputedStyle(el);
  width += parseInt(style.marginLeft) + parseInt(style.marginRight);
  return width;
};

export const outerHeight = (el: HTMLElement): number => {
  let height = el.offsetHeight;

  const style = window.getComputedStyle(el);
  height += parseInt(style.marginTop) + parseInt(style.marginBottom);
  return height;
};

export default outerWidth;
